class ReferralHistory{
	constructor(customer){
		this.customer=customer;
	}
	renderReferralHistory() {
		 $(".swell-referal-history-div").removeClass("hidden-div").addClass("showing-div");
		 $(".swell-refferal-back");

		  // $(".swell-refferal-back .swell-referral-img").addClass("hidden-div");
		$(".swell-referral-history").append(
			$("<table>").addClass("swell-referral-history-table").append(
				$("<thead>").append(
					$("<tr>").append(
						$("<td>").text("Email"),
						$("<td>").text("Status"),
					)
				),
				$("<tbody>")
			)
		);
		if (swellAPI.getCustomerDetails().referrals.length >0) {
			$(".swell-referral-img").css("background-image", "unset");
			$(".swell-referral-container").addClass("referral-container-long")
		}
		// $(".swell-refferal-back").css("background-position", "60%");
		this.populateReferredEmails();
	}

	populateReferredEmails() {
		console.log(this.customer.referrals);
		this.customer.referrals.forEach(referrel => {
			console.log(referrel.email);
			$(".swell-referral-history table tbody").append(
				$("<tr>").append(
					$("<td>").text(referrel.email),
					$("<td>").text(`${referrel.completedAt === null ? "Invited" : "Purchased"}`)
				)
			)
		})
	}
}